var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoneBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.75 5l-8 8-3.5-3.5C3.75 9 3 9 2.5 9.5s-.5 1.25 0 1.75l4.375 4.375c.25.25.5.375.875.375s.625-.125.875-.375L17.5 6.75c.5-.5.5-1.25 0-1.75s-1.25-.5-1.75 0z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS43NSA1bC04IDgtMy41LTMuNUMzLjc1IDkgMyA5IDIuNSA5LjVzLS41IDEuMjUgMCAxLjc1bDQuMzc1IDQuMzc1Yy4yNS4yNS41LjM3NS44NzUuMzc1cy42MjUtLjEyNS44NzUtLjM3NUwxNy41IDYuNzVjLjUtLjUuNS0xLjI1IDAtMS43NXMtMS4yNS0uNS0xLjc1IDB6Ii8+Cjwvc3ZnPgo=";
export { SvgDoneBig as ReactComponent };